const DEFAULT_SCRIPT_URL = 'https://js.hsforms.net/forms/embed/developer/21902860.js';
const LEGACY_SCRIPT_URL = '//js.hsforms.net/forms/embed/v2.js';
const scriptLoaders = new Map();
const isBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';
const findScript = (url) => Array.from(document.scripts).find(({ src }) => src === url);
const markScriptLoaded = (script) => {
    script.dataset.hdLoaded = 'true';
};
const isScriptLoaded = (script) => script.dataset.hdLoaded === 'true';
const bindExistingScript = (script, url) => {
    if (isScriptLoaded(script)) {
        return Promise.resolve();
    }
    const cachedLoader = scriptLoaders.get(url);
    if (cachedLoader) {
        return cachedLoader;
    }
    const loader = new Promise((resolve, reject) => {
        const handleLoad = () => {
            markScriptLoaded(script);
            scriptLoaders.set(url, Promise.resolve());
            resolve();
        };
        const handleError = () => {
            scriptLoaders.delete(url);
            reject(new Error(`Failed to load HubSpot script: ${url}`));
        };
        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
    });
    scriptLoaders.set(url, loader);
    return loader;
};
const loadScriptOnce = (url) => {
    if (!isBrowser()) {
        return Promise.resolve();
    }
    const existingScript = findScript(url);
    if (existingScript) {
        return bindExistingScript(existingScript, url);
    }
    const cachedLoader = scriptLoaders.get(url);
    if (cachedLoader) {
        return cachedLoader;
    }
    const loader = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.src = url;
        script.onload = () => {
            markScriptLoaded(script);
            scriptLoaders.set(url, Promise.resolve());
            resolve();
        };
        script.onerror = () => {
            scriptLoaders.delete(url);
            reject(new Error(`Failed to load HubSpot script: ${url}`));
        };
        document.head.appendChild(script);
    });
    scriptLoaders.set(url, loader);
    return loader;
};
const hasLegacyHubspotApi = () => { var _a, _b; return typeof window !== 'undefined' && !!((_b = (_a = window.hbspt) === null || _a === void 0 ? void 0 : _a.forms) === null || _b === void 0 ? void 0 : _b.create); };
export const hasModernHubspotScript = () => typeof document !== 'undefined' && !!findScript(DEFAULT_SCRIPT_URL);
export const loadLegacyHubspotScript = () => {
    if (hasLegacyHubspotApi()) {
        return Promise.resolve();
    }
    return loadScriptOnce(LEGACY_SCRIPT_URL);
};
export const loadModernHubspotScript = () => {
    if (hasModernHubspotScript()) {
        return Promise.resolve();
    }
    return loadScriptOnce(DEFAULT_SCRIPT_URL);
};
